/**
 * Whether the day's fuller nutrition breakdown is open.
 *
 * One boolean for the whole app, not one per day like `open-meals.ts`. The
 * meals are an arrangement *of a particular day* — dinner open at seven on
 * Tuesday says nothing about Wednesday — but whether you care about fibre and
 * salt is a standing preference about the screen, and re-collapsing it every
 * morning would make it a thing you reopen daily rather than a thing you set.
 *
 * Shut by default. The ring and the three macro bars are what Today is for,
 * and the sparseness of that is deliberate; this is the answer to a question
 * you have to think to ask.
 *
 * Wrapped like every other storage access here: Safari with site data blocked
 * throws rather than returning null, and a private window is not a reason for
 * Today to be a white page.
 */

const KEY = "calorio:today-more";

export function moreOpen(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setMoreOpen(open: boolean): void {
  try {
    localStorage.setItem(KEY, open ? "1" : "0");
  } catch {
    // It still opens for this visit; it just does not survive leaving.
  }
}
